// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2I5Nq","largestCol":"styles_largestCol__CtGA6","smallestCol":"styles_smallestCol__POt2C"};